import { isValidPassword } from "@wevideo/core/utils/PasswordUtils";

import { isProduction } from "./GeneralHelper";

export {
	PASSWORD_REQUIREMENTS,
	getPasswordRequirements,
	isValidPassword,
	validatePasswordComplexity,
} from "@wevideo/core/utils/PasswordUtils";

export const isValidPasswordForEnv = (password: string): boolean =>
	!isProduction() || isValidPassword(password);

export const isValidEmail = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
